<template>
    <div class="collapsible-body">
        <div class="row baseheader" style="width: 100%;" v-if="newDeviceCategory == undefined">
            <div class="col s3 input-field">
                <span v-on:click="setDeviceCategoriesOrder('name')">{{$t('device_categories.name_placeholder')}}</span>
                <i class="material-icons dp6" v-if="orderdevicecategoriesby == 'name' && orderdevicecategories == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="orderdevicecategoriesby == 'name' && orderdevicecategories == 'asc'">arrow_drop_up</i>
                <input v-model="devcatsearch" />
            </div>
            <div class="col s1 input-field">
                <span v-on:click="setDeviceCategoriesOrder('prefix')">{{$t('device_categories.prefix')}}</span>
                <i class="material-icons dp6" v-if="orderdevicecategoriesby == 'prefix' && orderdevicecategories == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="orderdevicecategoriesby == 'prefix' && orderdevicecategories == 'asc'">arrow_drop_up</i>
                <input v-model="devcatprefixsearch" />
            </div>
            <div class="col s8 input-field" style="text-align: end;" v-if="role == 'ddd_admin' || (role == 'ddd_worker' && extended_privileges)">
                <a class="waves-effect waves-light btn solidgreen" v-on:click="addDeviceCategory()" style="margin-top: 20px;">{{$t('device_categories.add_category')}}</a>
            </div>
        </div>
        <ul class="collapsible">
            <li v-if="newDeviceCategory != undefined">
                <devicecategory 
                    v-bind:device_category="newDeviceCategory" 
                    v-bind:substances="substanceoptions" 
                    v-on:addedDeviceCategory="devcatAdded"  
                    v-on:cancelDeviceCategory="cancelledDeviceCategory"
                    :extended_privileges="extended_privileges"
                    :role="role"
                    ref="newDeviceCategory"/>
            </li>
            <li v-for="device_category in listDeviceCategories">
                <div class="collapsible-header reded">
                    <div class="row" style="width: 100%;">
                        <div class="col s3">
                            {{device_category.name}}
                        </div>
                        <div class="col s1">
                            {{device_category.prefix}}
                        </div>
                    </div>
                </div>
                <devicecategory
                    v-bind:device_category="device_category"
                    v-bind:substances="substanceoptions"
                    v-on:removeDeviceCategory="devcatRemoved"
                    :extended_privileges="extended_privileges"
                    :role="role"
                    ref="deviceCategories" />
            </li>
            <li>
                <div class="row" style="width: 100%;" v-if="devicecategories_loaded == false">
                    <div class="col s12">
                        <div class="container" style="width: 3%; margin: auto;">
                            <div class="preloader-wrapper active">
                                <div class="spinner-layer spinner-red-only">
                                    <div class="circle-clipper left">
                                        <div class="circle"></div>
                                    </div>
                                    <div class="gap-patch">
                                        <div class="circle"></div>
                                    </div>
                                    <div class="circle-clipper right">
                                        <div class="circle"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';

export default {
    props: { role: String, extended_privileges: Boolean },
    data: function() {
        return {
            orderdevicecategories: 'desc',
            orderdevicecategoriesby: 'name',
            devcatsearch: "",
            devcatprefixsearch: "",
            device_categories: [],
            device_categories_options: [],
            device_categories_selected: [],
            devicecategories_loaded: false,
            substanceoptions: [],
            newDeviceCategory: undefined,
        }
    },
    created() {
        this.fetch_categories();
    },
    mounted() {
        var elems = document.querySelectorAll('.collapsible');
        var instances = M.Collapsible.init(elems, { accordion: true });
    },
    methods: {
        anyEdited: function(){
            if(_.isUndefined(this.$refs.deviceCategories) == false){
                for (var i = this.$refs.deviceCategories.length - 1; i >= 0; i--) {
                    if(this.$refs.deviceCategories[i].device_category.edit){
                        return true;
                    }
                }
            }
            if(_.isUndefined(this.$refs.newDeviceCategory) == false){
                if(this.$refs.newDeviceCategory.device_category.edit){
                    return true;
                }
            }
            return false;
        },
        fetch_categories: function() {
            axios.get('/substances.json').then(response => {
                this.substances = response.data;
                this.substanceoptions = []
                for (var i = this.substances.length - 1; i >= 0; i--) {
                    this.substances[i].edit = false;
                    this.substancegroups = _.uniq(_.union(this.substancegroups, this.substances[i].group))
                    this.substanceoptions.push({ name: this.substances[i].name, value: this.substances[i].id })
                }
                this.substancegroups = _.map(this.substancegroups, pestgroup => {
                    return { name: pestgroup, value: pestgroup };
                })

                this.substances_loaded = true;
            });
            axios.get('/device_categories.json').then(response => {
                this.device_categories = response.data;
                for (var i = this.device_categories.length - 1; i >= 0; i--) {
                    this.device_categories[i].edit = false;
                }
                this.devicecategories_loaded = true;
            });
        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }

            } else {
                this.orderby = order;
            }
        },
        cancelledDeviceCategory(){
          this.newDeviceCategory = undefined;
        },
        addDeviceCategory() {
            this.newDeviceCategory = { edit: true, tag_list: [], name: "", prefix: "", criterium: { method: "standard", critical_point: 2 }, substance_ids: [], graph_color: "#FF0000", editable: true }
            this.$forceUpdate();
        },
        devcatRemoved(devcat) {
            if (confirm("Czy chcesz usunąć " + devcat.name + " ?")) {
                axios.delete('/device_categories/' + devcat.id + '.json').then(response => {
                    this.device_categories.splice(this.device_categories.indexOf(devcat), 1);
                })
            }
        },
        devcatAdded(devcat) {
            this.device_categories.push(devcat)
        },
        setDeviceCategoriesOrder: function(order) {
            if (this.orderdevicecategoriesby == order) {
                if (this.orderdevicecategories == 'desc') {
                    this.orderdevicecategories = 'asc'
                } else if (this.orderdevicecategories == 'asc') {
                    this.orderdevicecategories = 'desc'
                }

            } else {
                this.orderdevicecategoriesby = order;
            }
        },
    },
    computed: {

        listDeviceCategories() {
            var that = this;
            return _.filter(
                _.orderBy(this.device_categories, this.orderdevicecategoriesby, this.orderdevicecategories),
                function(item) {
                    return (item.name.toUpperCase().indexOf(that.devcatsearch.toUpperCase()) >= 0) && (item.prefix.toUpperCase().indexOf(that.devcatprefixsearch.toUpperCase()) >= 0)
                }
            );
        },

    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.settingsform {
    padding-top: 15px;
}

.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

.selectorignored select {
    display: block;
}

.formul .row .col {
    padding-bottom: 15px;
}

.formul .s12 .input-field {
    width: 90%
}

.formul .s4 .input-field {
    width: 60%
}

.formul .s6 .input-field {
    width: 60%
}

.input-field {
    margin: 0px !important;
}

.settingsform>.row {
    margin-bottom: 0px;
}

.settingsform>.row>.collapsible {
    margin-bottom: 0px;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.collapsible-header {
    background-color: #8A8D91;
    text-transform: uppercase;
}

.collapsible-body .collapsible-header {
    background-color: #FFF;
    text-transform: initial;
}

.collapsible-body .collapsible-header .row {
    margin-bottom: 0px;
}

.collapsible-body .collapsible-body.formul {
    background-color: #FFF;
    margin-top: 5px;
    border-bottom-style: solid;
    border-bottom-width: 5px;
}

.baseheader {
    background-color: #DADADA;
    margin-bottom: 0px;
}

.collapsible {

    margin-left: 15px;
    margin-right: 15px;
    box-shadow: 0 0px 0px;
    border: 0px;
}

.collapsible li {
    padding-bottom: 15px;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.solidgreen {
    background-color: #00CC66 !important;
    color: black;
}

.active>.reded {
    border-color: rgb(194, 32, 38);
    border: 4px solid rgb(194, 32, 38);
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.inline>select {
    display: block !important;
}

.collapsible-body {
    padding: 1em;
    padding-right: 0em;
    padding-left: 1em;
}

.collapsible li i {
    position: absolute;
    right: 15px;
}

.collapsible li.active i {
    -ms-transform: rotate(180deg);
    /* IE 9 */
    -webkit-transform: rotate(180deg);
    /* Chrome, Safari, Opera */
    transform: rotate(180deg);
}

.input-field {
    margin-top: 0rem;
    margin-bottom: 0rem;
}

.btn-small {
    color: black;
    border-radius: 8px;
}
</style>